import LocaleStrings from "Languages";
import { DEVELOPMENT_TYPE } from "Constants";

export default function () {
  return DEVELOPMENT_TYPE === "koachify"
    ? [
        // {
        //   title: LocaleStrings.setting_submenu_title1,
        //   iconName: "passwordsetting",
        //   description: LocaleStrings.setting_submenu_description1,
        // },//will be now under account settings
        {
          title: LocaleStrings.setting_submenu_title5,
          iconName: "eventsetting",
          description: LocaleStrings.setting_submenu_description5,
        },
        {
          title: LocaleStrings.setting_submenu_title2,
          iconName: "emailtemplate",
          description: LocaleStrings.setting_submenu_description2,
        },
      ]
    : [
        {
          title: LocaleStrings.setting_submenu_title1,
          iconName: "passwordsetting",
          description: LocaleStrings.setting_submenu_description1,
        }, //will be now under account settings
        {
          title: LocaleStrings.setting_submenu_title5,
          iconName: "eventsetting",
          description: LocaleStrings.setting_submenu_description5,
        },
        {
          title: LocaleStrings.setting_submenu_title2,
          iconName: "emailtemplate",
          description: LocaleStrings.setting_submenu_description2,
        },
        // {
        //   title: LocaleStrings.setting_submenu_title3,
        //   iconName: "appstore",
        //   description: LocaleStrings.setting_submenu_description3,
        // },
        {
          title: LocaleStrings.setting_submenu_title4,
          iconName: "emaillog",
          description: LocaleStrings.setting_submenu_description4,
        },
        {
          title: LocaleStrings.setting_submenu_integration_title,
          iconName: "apis",
          description: LocaleStrings.setting_submenu_integration_description6,
        },
        // {
        //   title: LocaleStrings.setting_submenu_title7,
        //   iconName: "billings",
        //   description: LocaleStrings.setting_submenu_description7,
        // },//will be now under account settings
        {
          title: LocaleStrings.setting_submenu_language_title,
          iconName: "language",
          description: LocaleStrings.setting_submenu_language_description,
        },
      ];
}
